import { ConditionalRenderProps } from './types'

const ConditionalRender = <T,>({ condition, render }: ConditionalRenderProps<T>) => {
  return !condition ? null : <>{render(condition)}</>
}

export default ConditionalRender
